import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigService } from 'src/app/services/config.service';
export class PopoverComponent {
    constructor(popoverController, authService, configService) {
        this.popoverController = popoverController;
        this.authService = authService;
        this.configService = configService;
        this.post = {};
        this.reactionDeleted = new EventEmitter();
        this.oldReaction = '';
    }
    closePopover() {
        this.popoverController.dismiss();
    }
    ngOnInit() {
        if (this.post.reaction == '' || this.post.reaction == null) {
            this.configService.userHasAlreadyPosted = false;
        }
        else if (this.post.reaction.length > 0) {
            this.configService.userHasAlreadyPosted = true;
        }
    }
    changeReaction(reaction) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                this.validateReaction(reaction);
                if (this.post.reaction) {
                    this.configService.createReaction(this.authService.player_initial_data.id, this.post.id, this.post.reaction);
                    this.closePopover();
                }
                else {
                    this.configService.deleteReaction(this.authService.player_initial_data.id, this.post.id, reaction);
                    this.configService.notifyReactionDeleted(reaction, this.post.id);
                    this.closePopover();
                }
            }
            catch (error) {
                console.error('[PRODUCT-COMPONENT] changeReaction()', error);
            }
        });
    }
    validateReaction(reaction) {
        if (this.post.reaction == '' || this.post.reaction == null) {
            this.oldReaction = '';
        }
        else {
            this.oldReaction = this.post.reaction;
        }
        let quantityNewReaction = this.post.count_reactions[reaction];
        if (this.post.reaction == reaction) {
            this.post.reaction = '';
            if (quantityNewReaction > 0) {
                this.post.count_reactions[reaction]--;
            }
            else {
                this.post.count_reactions[this.oldReaction]--;
                let hx = this.post.count_reactions[reaction];
                console.log(hx);
            }
            this.closePopover();
        }
        else if (this.post.reaction == '' || this.post.reaction == null) {
            this.post.reaction = reaction;
            this.post.count_reactions[reaction]++;
            if (!this.configService.userHasAlreadyPosted) {
                this.post.count_reactions['total_count']++;
                this.configService.userHasAlreadyPosted = true;
            }
            this.closePopover();
        }
        else {
            // Increment the new reaction
            this.post.count_reactions[reaction]++;
            // Decrement the previous reaction
            this.post.count_reactions[this.oldReaction]--;
            this.post.reaction = reaction;
            if (!this.configService.userHasAlreadyPosted) {
                this.post.count_reactions++;
                this.configService.userHasAlreadyPosted = true;
            }
            this.closePopover();
        }
    }
}
